import { InitCardStudioDevToolsArgs } from './DevToolsContext'

// All default should be OFF if you aren't checking devToolsEnabled!
// Production users could get these options!
export const devToolsEnabled = process.env['NODE_ENV'] === 'development' || process.env['NODE_ENV'] === 'test'
export const DEFAULT_DEVTOOLS_SETTINGS = {
  cardStudioTools: false,
  reactQueryTools: false,
  reactReduxTools: devToolsEnabled,
}
export const INITIAL_CARD_STUDIO_STATE = {
  context: null as CanvasRenderingContext2D | null,
  metrics: {} as InitCardStudioDevToolsArgs['metrics'],
  imageData: '',
  showGrid: false,
  showCoordinates: false,
  strokeOptions: {},
  shouldCreatePreview: false,
}

export type DevToolsSettings = typeof DEFAULT_DEVTOOLS_SETTINGS
export type CardStudioState = typeof INITIAL_CARD_STUDIO_STATE
export type ToolKey = keyof typeof DEFAULT_DEVTOOLS_SETTINGS

type ToggleAction = { type: 'TOGGLE'; key: ToolKey }
type UpdateImageData = { type: 'UPDATE_IMAGE_DATA'; imageData: string }
type ToggleCardStudioOption = { type: 'TOGGLE_CARD_STUDIO_OPTION'; key: 'showGrid' | 'showCoordinates' }
type TogglePreviewAction = { type: 'TOGGLE_PREVIEW'; value: boolean }
type SetContextAction = { type: 'SET_CONTEXT'; context: CanvasRenderingContext2D }
type SetMetricsAction = {
  type: 'SET_METRICS'
  metrics: InitCardStudioDevToolsArgs['metrics']
}
type SetStrokeOptionsAction = {
  type: 'SET_STROKE_OPTIONS'
  strokeOptions: InitCardStudioDevToolsArgs['strokeOptions']
}

export function enabledReducer(state: typeof DEFAULT_DEVTOOLS_SETTINGS, action: ToggleAction) {
  switch (action.type) {
    case 'TOGGLE':
      return { ...state, [action.key]: !state[action.key] }
    default:
      return state
  }
}

export function cardStudioReducer(
  state: typeof INITIAL_CARD_STUDIO_STATE,
  action:
    | UpdateImageData
    | ToggleCardStudioOption
    | SetContextAction
    | SetMetricsAction
    | SetStrokeOptionsAction
    | TogglePreviewAction
) {
  switch (action.type) {
    case 'SET_CONTEXT':
      return { ...state, context: action.context }
    case 'SET_METRICS':
      return { ...state, metrics: action.metrics }
    case 'UPDATE_IMAGE_DATA':
      return { ...state, imageData: action.imageData }
    case 'TOGGLE_CARD_STUDIO_OPTION':
      return { ...state, [action.key]: !state[action.key] }
    case 'SET_STROKE_OPTIONS':
      return { ...state, strokeOptions: action.strokeOptions }
    case 'TOGGLE_PREVIEW':
      return { ...state, shouldCreatePreview: action.value }
    default:
      return state
  }
}
